import { Axios } from "./request";

const API_URL = "usersapi/v1/users/GetHodaInfo/";

export const GET_HODA_INFO = {
  get: () => {
    return Axios.get(API_URL);
  },
};
